import { asLabel } from '@shure/shared/angular/utils/i18n';

export function mapMuteStatusToTranslocoKey(isMuted: boolean): string {
	return isMuted ? asLabel('shAgGrid.common.labels.muted') : asLabel('shAgGrid.common.labels.un-muted');
}
